import LanguageSelector from '../../shared/LanguageSelector';

export default LanguageSelector;
